


















import { TagStateModule, UserStateModule } from '@/store';
import { FeedModel, CommentModel } from '@/type/api';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FeedContentBody from './FeedContentBody.vue';
import FeedContentCommentForm from './FeedContentCommentForm.vue';
import FeedContentImageWrapper from './FeedContentImageWrapper.vue';
import FeedContentComments from './FeedContentComments.vue';
import FeedContentHeader from './FeedContentHeader.vue';
import FeedContentInfoStatuses from './FeedContentInfoStatuses.vue';
import FeedContentButtonsContainer from './FeedContentButtonsContainer.vue';
import FeedContentTags from './FeedContentTags.vue';

@Component<FeedContainer>({
  inheritAttrs: false,
  components: {
    FeedContentHeader,
    FeedContentImageWrapper,
    FeedContentBody,
    FeedContentButtonsContainer,
    FeedContentInfoStatuses,
    FeedContentTags,
    FeedContentComments,
    FeedContentCommentForm,
  },
})
export default class FeedContainer extends Vue {
  // PROPS
  @Prop({ type: Object, required: true })
  feed!: FeedModel.Read.Response.Feed;
  @Prop({ type: Array, required: true })
  comments!: CommentModel.Read.Response.List[];

  // MUTATIONS
  get getComment() {
    return (moduleId: number) => this.comments.filter((c) => c.module_id === moduleId);
  }
  get getFeedStatuses() {
    return (feed: FeedModel.Read.Response.Feed) => [
      {
        name: this.$t('favorite'),
        cnt: feed.favorite_cnt,
      },
      {
        name: this.$t('comment'),
        cnt: feed.comment_cnt,
      },
    ];
  }
}
